"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../Header/Button"));

var _CurrentYear = _interopRequireDefault(require("../Header/CurrentYear"));

var _JumpButton = _interopRequireDefault(require("../Header/JumpButton"));

var _yearsList = _interopRequireDefault(require("../Body/yearsList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint jsx-a11y/anchor-is-valid: "off"*/
function PickerPanel(_ref) {
  var selectedYear = _ref.selectedYear,
      isOpen = _ref.isOpen,
      increaseYear = _ref.increaseYear,
      decreaseYear = _ref.decreaseYear,
      jumpForward = _ref.jumpForward,
      jumpBackward = _ref.jumpBackward,
      thisYear = _ref.thisYear,
      choiseYear = _ref.choiseYear,
      thisYearLabel = _ref.thisYearLabel;

  if (!isOpen) {
    return null;
  }

  function headerWheel(e) {
    e.preventDefault();
    var delta = e.deltaY;

    if (delta < 0) {
      increaseYear();
    } else {
      decreaseYear();
    }
  }

  return _react.default.createElement("div", {
    className: "picker-panel popup-left"
  }, _react.default.createElement("div", {
    className: "header",
    onWheel: headerWheel
  }, _react.default.createElement(_JumpButton.default, {
    onClick: jumpBackward,
    direction: "backward"
  }), _react.default.createElement(_Button.default, {
    onClick: decreaseYear,
    direction: "backward"
  }), _react.default.createElement(_CurrentYear.default, {
    year: selectedYear
  }), _react.default.createElement(_Button.default, {
    onClick: increaseYear,
    direction: "forward"
  }), _react.default.createElement(_JumpButton.default, {
    onClick: jumpForward,
    direction: "forward"
  })), _react.default.createElement("div", {
    className: "body"
  }, _react.default.createElement(_yearsList.default, {
    choiseYear: choiseYear,
    selectedYear: selectedYear
  })), _react.default.createElement("div", {
    className: "footer"
  }, _react.default.createElement("span", {
    className: "footer-btn"
  }, _react.default.createElement("a", {
    className: "footer-today",
    onClick: thisYear
  }, thisYearLabel))));
}

var _default = PickerPanel;
exports.default = _default;